var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedMemberFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H20V23L12 17.5L4 23V1Z",
    fill: "#26B3C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H12V18L4 23V1Z",
    fill: "#1E94A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5011 22.998L19.5299 22.9981C19.7883 22.9824 19.9988 22.765 20 22.4987V2.25C20 1.56128 19.4387 1 18.75 1H5.25C4.56128 1 4 1.56128 4 2.25V22.5C4.00057 22.6074 4.0327 22.7051 4.09546 22.7915C4.18746 22.9178 4.34141 22.997 4.502 22.997C4.60932 22.997 4.70796 22.9651 4.79583 22.9015C4.79593 22.9015 4.79603 22.9014 4.79614 22.9013L10.9719 18.4102L10.9741 18.4086C11.271 18.194 11.6272 18.075 12.001 18.075C12.3748 18.075 12.731 18.194 13.0279 18.4086L13.0302 18.4103L19.2068 22.903L19.5011 22.998ZM19.5011 22.998C19.3909 22.9977 19.2919 22.9647 19.2072 22.9033L19.5011 22.998Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedMemberFlag);
export default __webpack_public_path__ + "static/media/verified-member-flag.90d53b987550d827d608a79981af4d80.svg";
export { ForwardRef as ReactComponent };